import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/auth";

// Polls new licence requests for the admin; optional toast when the count grows.
export function useUnseenOrders(enabled = true, notify = false) {
  const [count, setCount] = useState(0);
  const prev = useRef(null);
  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => axios.get(`${API}/admin/license-orders/unseen-count`).then(r => {
      const c = r.data.count || 0;
      if (notify && prev.current !== null && c > prev.current) {
        toast("Nouvelle demande de licence", { description: `${c - prev.current} nouvelle(s) demande(s) à traiter.` });
      }
      prev.current = c; setCount(c);
    }).catch(() => {});
    tick();
    const id = setInterval(tick, 30000);
    const reset = () => { prev.current = 0; setCount(0); };
    window.addEventListener("lhs-orders-seen", reset);
    return () => { clearInterval(id); window.removeEventListener("lhs-orders-seen", reset); };
  }, [enabled, notify]);
  return count;
}
